import axios from "axios";
import React, { useState } from "react";
import PopupError from "./PopupError";
import PopupSuccess from "./PopupSuccess";
import { TailSpin } from "react-loader-spinner";

const EmailForm = () => {
  const sendMail = process.env.REACT_APP_SEND_EMAIL_API;
  const [mailFormVisible, setMailFormVisible] = useState(true);
  const [userSaved, setUserSaved] = useState(false);
  const [successPopupVisible, setSuccessPopupVisible] = useState(false);
  const [popupSuccessMsg, setPopupSuccessMsg] = useState("");
  const [errPopupVisible, setErrPopupVisible] = useState(false);
  const [popUpErrType, setPopUpErrType] = useState("");
  const [popUpErrMsg, setPopUpErrMsg] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSend = async (e) => {
    e.preventDefault();

    try {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!formData.name || !formData.email || !formData.message) {
        setErrPopupVisible(true);
        setPopUpErrMsg("All fields are required!");
      } else if (!emailRegex.test(formData.email)) {
        setErrPopupVisible(true);
        setPopUpErrType("Invalid Email ID");
        setPopUpErrMsg("Please enter a valid email address!");
      } else {
        setMailFormVisible(false);
        setUserSaved(true);
      }

      const formDataToSend = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
      };

      const res = await axios.post(sendMail, formDataToSend, {
        headers: { "Content-Type": "application/json" },
      });
      if (res.status === 200) {
        setUserSaved(false);
        setMailFormVisible(true);
        setSuccessPopupVisible(true);
        setPopupSuccessMsg("Email sent successfully");
        setFormData({ name: "", email: "", message: "" });
      }
    } catch (error) {
      console.error("error : ", error);
      setMailFormVisible(true);
      setUserSaved(false);
    }
  };

  return (
    <div>
      <div>
        {errPopupVisible ? (
          <PopupError
            errType={popUpErrType}
            errMsg={popUpErrMsg}
            onClose={() => {
              setErrPopupVisible(false);
              setPopUpErrType("");
              setPopUpErrMsg("");
            }}
          />
        ) : null}
      </div>
      <div>
        {successPopupVisible && (
          <PopupSuccess
            successMsg={popupSuccessMsg}
            isClose={() => setSuccessPopupVisible(false)}
          />
        )}
      </div>
      {userSaved && (
        <div className="tailspin" style={{ height: "422px" }}>
          <div className="tailspin-sub">
            <TailSpin />
          </div>
        </div>
      )}
      {mailFormVisible && (
        <form id="contact" action="" method="post">
          <div className="row">
            <div className="col-md-6">
              <fieldset>
                <input
                  name="name"
                  type="text"
                  className="form-control"
                  id="name"
                  placeholder="Your Name"
                  required=""
                  onChange={handleChange}
                  value={formData.name}
                />
              </fieldset>
            </div>
            <div className="col-md-6">
              <fieldset>
                <input
                  name="email"
                  type="text"
                  className="form-control"
                  id="email"
                  placeholder="Your Email"
                  required=""
                  onChange={handleChange}
                  value={formData.email}
                />
              </fieldset>
            </div>
            <div className="col-md-12">
              <fieldset>
                <textarea
                  name="message"
                  rows="6"
                  className="form-control"
                  id="message"
                  placeholder="Your message..."
                  required=""
                  onChange={handleChange}
                  value={formData.message}
                ></textarea>
              </fieldset>
            </div>
            <div className="col-md-12">
              <fieldset>
                <div className="main-button">
                  <button onClick={handleSend}>Send Message Now</button>
                </div>
              </fieldset>
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default EmailForm;
